import React from "react";
import { useTheme } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { Typography, Stack } from "@mui/material";

const AutobiaDatePicker = ({
  value,
  onChange,
  title,
  height = "40px",
  placeholder = "Select date",
  disabled = false,
  error = false,
  helperText,
  fullWidth = true,
  color = "primary",
}) => {
  const theme = useTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack sx={{ width: fullWidth ? "100%" : "auto" }}>
        {title && (
          <Typography
            variant="body2"
            color={theme.palette.gray.g600}
            fontWeight={600}
            sx={{ mb: 0.5 }}
          >
            {title}
          </Typography>
        )}
        <DatePicker
          value={value ? moment(value) : null}
          onChange={(newValue) => {
            if (onChange) {
              onChange(newValue ? newValue.toDate() : null);
            }
          }}
          disabled={disabled}
          label={placeholder}
          slotProps={{
            textField: {
              error: error,
              helperText: helperText,
              sx: {
                width: "100%",
                backgroundColor: "white",
                borderRadius: "10px",
                height: height,
                "& .MuiOutlinedInput-root": {
                  height: "100%",
                  borderRadius: "10px",
                  "& fieldset": {
                    borderRadius: "10px",
                  },
                  "& .MuiInputBase-input": {
                    padding: "10px 14px",
                    height: "100%",
                    boxSizing: "border-box",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: color === "secondary"
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: theme.palette.gray.g50,
                  },
                  "&.Mui-error fieldset": {
                    borderColor: theme.palette.error.main,
                  },
                },
              },
            },
            popper: {
              sx: {
                "& .MuiPickersDay-root": {
                  color: theme.palette.text.primary,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.light,
                  },
                },
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                  },
                },
                "& .MuiPickersDay-root.MuiPickersDay-today": {
                  border: `2px solid ${theme.palette.primary.main}`,
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                },
                "& .MuiPickersDay-root.MuiPickersDay-today.Mui-selected": {
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  border: "none",
                },
                "& .MuiPickersCalendarHeader-root": {
                  "& .MuiIconButton-root": {
                    color: theme.palette.primary.main,
                  },
                },
              },
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default AutobiaDatePicker;